import React, { useContext, useState, useEffect } from "react";
import Swal from "sweetalert2";
import { links } from "../../functions/links";
import AlertSuccess from "../CustomAlerts/AlertSuccess";
import { Spinner, CreditosContext, clienteAxios, useHistory } from "../shared/";
import { BotonAgregar } from "../shared/Estilos";
import { Input } from "../shared/FormsElements";
import Listar from "./ListarCreditos";
import ModalEditarCredito from "./modals/ModalEditarCredito";
import Tabla_creditos from "./tablas/Tabla_creditos";
import { useParams } from "react-router-dom/cjs/react-router-dom";
import Modal from "../../module/modal/Modal";
import "../shared/styles/ViewContainer.css";


const Creditos = (props) => {
  const Context = useContext(CreditosContext);
  const { usuarios, cargando, obtenerUsuariosII } = Context;
  const history = useHistory();
  const { id } = useParams();
  //States
  const [modalEditarCredito, setModalEditarCredito] = useState(false);
  const [select, setSelect] = useState(null);
  const [creditos, setCreditos] = useState(null);
  //Formularios
  const [DatosForm, LeerForm] = useState({ buscar: "" });
  const { buscar } = DatosForm;
  const [params, setParams] = useState({
    texto: id,
    page: 1,
    paginator: 15,
    estado: "",
  })
  const [selectStatus, setSelectStatus] = useState('Todos');

  const onChange = (e) => {
    LeerForm({
      ...DatosForm,
      [e.target.name]: e.target.value,
    });

    if (e.target.name == "buscar") {
      //obtenerUsuariosII(buscar);
      setParams({
        ...params,
        texto: e.target.value
      })
    }

    if (e.target.name == "estado") {

      let estado = e.target.value;

      if (e.target.value == 'Activos') {
        estado = ['Vigente', 'No Vigente', 'Cancelado', 'Pagado']
        setSelectStatus(e.target.value);

        setParams({
          ...params,
          estado: estado,
          page: 1
        })
        return
      }

      if (e.target.value == 'Todos') {
        estado = "";
        setSelectStatus(e.target.value);

        setParams({
          ...params,
          estado: estado,
          page: 1
        })
        return
      }


      setSelectStatus(e.target.value);
      setParams({
        ...params,
        estado: estado,
        page: 1
      })
    }

  };

  //Eventos
  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "anterior": {
        if (params.page !== 1) {
          setCreditos(null);
          setParams({
            ...params,
            page: params.page - 1
          })
        }
      } break;
      case "siguiente": {
        setCreditos(null);
        setParams({
          ...params,
          page: params.page + 1
        })
      } break;
      case "link": {
        setCreditos(null);
        setParams({
          ...params,
          page: value
        })
      } break;
      case "ver_credito":
        history.push("/creditos/ver/" + value.id);
        break;
      case "editar_credito": {
        setSelect(value);
        setModalEditarCredito(true);

        // Abrir modal manualmente
        setTimeout(() => {
          const modalElement = document.getElementById('btn-open-modal-editar-credito');
          if (modalElement) {
            modalElement.click();
          }
        }, 100);
      } break;
      case "delete_credito": {
        //LLave de administrador
        Swal.fire({
          title: "Eliminar credito",
          html:
            "<p>¿Quieres dar de baja el siguiente Credito?</p>" +
            '<ul class="list-group"><li class="list-group-item border-0 d-flex justify-content-between"><div>Nº de Credito </div><div>' +
            value.id,
          input: "password",
          inputAttributes: {
            autocapitalize: "off",
          },
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonText: "Eliminar",
          showLoaderOnConfirm: true,
          preConfirm: async (result) => {

            let formData = new FormData();
            formData.append("id", value.id);
            formData.append("status", 'Eliminado');
            formData.append("password", result);

            const response = await clienteAxios({
              method: "post",
              url: "/PersonaCreditos/delete",
              data: formData,
            }).then((result) => {
              Swal.fire({
                title: '¡Credito Eliminado!',
                text: 'El credito se elimino correctamente',
              });

              return window.location.reload();
            })
              .catch((result) => {
                return Swal.showValidationMessage(
                  `Request failed: ${result.response.data.messages.msg}`
                );
              });
          },
          allowOutsideClick: () => !Swal.isLoading(),
        }).then((result) => {
          console.log("ok");
        });

        /*
        Swal.fire({
          title: '¿Quieres eliminar el credito Nº'+value.id+'?',
          text: "",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Eliminar',
          cancelButtonText: "Cancelar"
        }).then(async (result) => {
          if (result.isConfirmed) {
            let formData = {
              id: value.id,
              status: 'Eliminado',
            }
    
            const result = await clienteAxios.post(
              "/PersonaCreditos/delete",
              formData
            );

            Swal.fire(
              '¡Credito Eliminado!',
              'El credito se elimino correctamente.',
              'success'
            )
    
            return window.location.reload();
          }
        })
*/

      } break;
    }
  }

  /*
  useEffect(() => {
    // eslint-disable-next-line no-console
    obtenerUsuariosII(buscar); 
  }, [buscar]);
  */

  useEffect(() => {
    const obtenerCreditos = async () => {
      try {
        const result = await clienteAxios.get(
          "/PersonaCreditos/getAll",
          { params }
        );
        setCreditos(
          result.data //.filter((result) => result.id_credito === null)
        );
        /*  console.log(result.data.creditos.filter(
          (result) => result.id_credito === null
        )); */
      } catch (e) { }
    };

    setCreditos(null)
    obtenerCreditos();
  }, [params])

  //Logs
  //console.log(creditos);
  return (
    <div className="view-container">
      <div className="view-header">
        <h1 className="view-title">Gestionar Créditos</h1>
        <div className="view-toolbar">
          <button
            onClick={() => props.history.push("/creditos/nuevo")}
            className="btn-add-primary"
          >
            <i className="bi bi-plus-lg"></i>
            Agregar Crédito
          </button>

          <div className="search-input-container">
            <input
              type="text"
              className="search-input"
              placeholder="Buscar crédito..."
              name="buscar"
              value={buscar}
              onChange={onChange}
            />
            <i className="bi bi-search search-icon"></i>
          </div>

          <select
            className="form-select"
            name="estado"
            onChange={onChange}
            value={selectStatus}
            style={{ width: "auto", minWidth: "140px", borderRadius: '12px', border: '2px solid #E2E8F0' }}
          >
            <option value="Todos">Todos</option>
            <option value="Activos">Activos</option>
            <option value="Eliminado">Eliminado</option>
          </select>
        </div>
      </div>

      {creditos ? (
        <>
          <div className="pagination-container fade-in">
            <div className="pagination-info">
              Total: {creditos.registros} registros
            </div>
            <div className="pagination-buttons">
              <button
                className="pagination-btn"
                name="anterior"
                onClick={(event) => onClick(event)}
                disabled={params.page === 1}
              >
                <i className="bi bi-arrow-left"></i>
              </button>

              {params.page > 1 && (
                <button
                  className="pagination-btn"
                  name="link"
                  onClick={(event) => onClick(event, 1)}
                >
                  1
                </button>
              )}

              <button className="pagination-btn pagination-btn-active">
                {creditos.pagina}
              </button>

              {links(creditos.pagina, creditos.paginas).map((link) => (
                <button
                  key={link}
                  className="pagination-btn"
                  name="link"
                  onClick={(event) => onClick(event, link)}
                >
                  {link}
                </button>
              ))}

              {creditos.pagina < creditos.paginas && (
                <button
                  className="pagination-btn"
                  name="link"
                  onClick={(event) => onClick(event, creditos.paginas)}
                >
                  {creditos.paginas}
                </button>
              )}

              <button
                className="pagination-btn"
                name="siguiente"
                onClick={(event) => onClick(event)}
                disabled={params.page === creditos.paginas}
              >
                <i className="bi bi-arrow-right"></i>
              </button>
            </div>
          </div>

          <Tabla_creditos
            data={creditos.creditos}
            onClick={onClick}
            onChange={onChange}
            select={select}
            setSelect={setSelect}
            modalEditarCredito={modalEditarCredito}
            setModalEditarCredito={setModalEditarCredito}
          />
        </>
      ) : (
        <Spinner />
      )}




      <button
        className="d-none"
        id="btn-open-modal-editar-credito"
        data-bs-toggle="modal"
        data-bs-target="#editar-credito"
      ></button>

      <Modal
        title="Editar Crédito"
        id="editar-credito"
        width={"1500px"}
        onClose={{
          name: "close",
          function: onClick,
        }}
        onClick={
          {
            name: "guardar",
            title: "Guardar",
            function: onClick,
          }
        }
        children={
          modalEditarCredito
            ? <ModalEditarCredito
              setModal={setModalEditarCredito}
              setSelect={setSelect}
              select={select}
            /> : ""
        }
      />
    </div>
  );
};

export default Creditos;
